import { format } from 'date-fns';

export const formatDate = (dateString) => {
    return dateString ? format(new Date(dateString), 'dd/MM/yyyy') : '';
};
